import { Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Select } from '@mui/material'
import { useEffect, useState } from 'react'
import { GiftCardStatus } from 'shared/models'
import { giftCardStatusText } from './status-utils'
import { adminService } from 'shared/api'

function GiftCardStatusDialog({
  giftCardId,
  initialStatus,
  onClose,
  open
}: {
  giftCardId: number
  initialStatus: GiftCardStatus
  open: boolean
  onClose: () => void
}) {
  const [status, setStatus] = useState(initialStatus)
  const [processing, setProcessing] = useState(false)

  useEffect(() => {
    if (open === true) {
      setStatus(initialStatus)
    }
  }, [open])

  async function handleStatusSave() {
    setProcessing(true)

    try {
      await adminService.giftCard.changeStatus(giftCardId, status)
    } finally {
      setProcessing(false)
      onClose()
    }
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Статус сертификата</DialogTitle>
      <DialogContent>
        <Select
          value={status}
          onChange={(ev) => {
            setStatus(ev.target.value as GiftCardStatus)
          }}
          fullWidth
          variant="standard"
          size="small"
        >
          {Object.keys(giftCardStatusText)
            .filter((el) => el !== 'Cancelled')
            .filter((el) => el !== 'Expired')
            .filter((el) => el !== 'Used')
            .map((key) => (
              <MenuItem key={key} value={key}>
                {giftCardStatusText[key]}
              </MenuItem>
            ))}
        </Select>
      </DialogContent>
      <DialogActions>
        <Button type="submit" variant="outlined" disabled={processing} onClick={handleStatusSave}>
          Сохранить
        </Button>
      </DialogActions>
    </Dialog>
  )
}
export { GiftCardStatusDialog }
